// extracted by mini-css-extract-plugin
export default {"link":"folders_toast-module__link--3y3MN"};